export default () => {

    const $banner = $('.js-banner');
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $banner.addClass('banner-full-mobile');
    } else {
        $banner.removeClass('banner-full-mobile');
    }
    const $link = $banner.find($('.banner-full__link'));
    const form = $banner.find('.banner-full__form');
    $('.js-banner-close').on('click', function(e) {
        $('.js-banner').hide();
    })

    $link.on('click', function(e) {
        form.submit();
    })

    form.on('submit', function(e) {
        e.preventDefault();
        $.ajax({
            method: 'POST',
            url: form.attr('action'),
            data: form.serialize(),
            success: () => {
                $banner.hide();
            },
            error: xhr => {
                alert('Возникла ошибка: ' + xhr.responseCode);
            }
        })
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/blocks/banner/index.js